import React, { useState, useEffect } from 'react';
import {
  Table,
  Rating,
  Input,
  Icon,
  Button,
  Accordion,
  Grid,
  Loader,
  Segment,
  Header
} from 'semantic-ui-react';
import {IoIosFunnel} from 'react-icons/io';

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { producaov2 } from '../../../../services/apis';
import {
  FullContainer,
  ContentContainer,
  Title,
  RowContainer,
  Label,
  Text,
  RatingCard,
  RatingFeedback,
  RatingHeaderContainer,
  RatingNumber,
  RatingTime,
  RatingUserId,
  RatingUserInfoContainer,
  RatingUserName,
  RatingUserReviemContainer,
  RatingsContainer,
  LoadMoreButtonContainer,
  ActionButtonsContainer,
  FilterButton,
  FilterIcon
} from './styles';
import NumericInput from '../../../../components/NumericInput';
import RangeDatePicker from '../../../../components/RangeDatePicker';

const UserRating = ({ ratingInfo = {}}) => {
  return (
    <RatingCard>
      <RatingHeaderContainer>
        <RatingTime>{formatDate(ratingInfo?.createdAt)}</RatingTime>
        <RatingNumber>{ratingInfo?.id}</RatingNumber>
      </RatingHeaderContainer>
      <RatingUserReviemContainer>
        <RatingUserInfoContainer>
          <RatingUserName>{ratingInfo?.user?.name}</RatingUserName>
          <RatingUserId>{ratingInfo?.id_pessoa}</RatingUserId>
        </RatingUserInfoContainer>
        <Rating rating={ratingInfo?.rating} maxRating={5} icon={'star'} disabled />
      </RatingUserReviemContainer>
      <RatingFeedback>{ratingInfo?.feedback}</RatingFeedback>
    </RatingCard>
  );
}

const Ratings = ({ratingsListData = [], loading = false}) => {
  if(loading) {
    return (
      <Loader active={loading} />
    )
  }

  return (
    <RatingsContainer>
      {ratingsListData.map(ratingInfo => {
        return <UserRating ratingInfo={ratingInfo} />
      })}
    </RatingsContainer>
  )
}

const formatDate = (unformattedDate) => {
  const date = new Date(unformattedDate);

  if(Number.isNaN(date)) {
    return 'Data inválida'
  }

  return date.toLocaleString('pt-BR');
}

const fetchUserRatings = async (filterOptions = null) => {
  try {
    const response = await producaov2.get('/admin/voittoapp/ratings', {
      params: filterOptions
    });

    return [null, response.data];
  } catch(error) {
    return [error, null];
  }
}

const RatingMetadata = ({ ratingMetadata }) => {
  if(!ratingMetadata) {
    return null;
  }

  const ratingAverage = Number(ratingMetadata?.ratingAverage).toFixed(2);

  return (
    <Segment basic padded textAlign='center'>
      <Header size='medium'>Nota média</Header>
      <Header size='huge'>{ratingAverage}</Header>
      <Rating size='large' maxRating={5} rating={ratingAverage} disabled icon='star'/>
      <Text>{`${ratingMetadata?.ratingCount} Avaliações`}</Text>
    </Segment>
  );
}

const ActionButtons = () => {
  return (
    <ActionButtonsContainer>
      <FilterButton>
        <FilterIcon />
        Filtrar
      </FilterButton>
    </ActionButtonsContainer>
  );
}

export default function VoittoAppRatings() {
  const [ratingsInformation, setRatingsInformation] = useState(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [ratingsFillter, setRatingsFilter] = useState({offset: 0});
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  useEffect(() => {
    const loadRatingInformations = async () => {
      const [error, data] = await fetchUserRatings(ratingsFillter);

      setRatingsInformation(data);
      setIsLoadingMore(false);
    }

    loadRatingInformations();
  }, [ratingsFillter]);

  const onLoadMorePress = () => {
    setIsLoadingMore(true);
    setRatingsFilter(prev => ({...prev, offset: prev?.offset + 50}));
  }

  return (
    <FullContainer>
      <AdminMenu />
      <ContentContainer>
        <Title>Avaliações VoittoApp</Title>
        <RatingMetadata
          ratingMetadata={ratingsInformation?.metadata}
        />
        <Ratings
          loading={!ratingsInformation}
          ratingsListData={ratingsInformation?.ratingList}
        />
        {!ratingsInformation || (
          <LoadMoreButtonContainer>
            <Button
              fluid
              loading={isLoadingMore}
              onClick={onLoadMorePress}
            >
              Carregar Mais
            </Button>
          </LoadMoreButtonContainer>
        )}
      </ContentContainer>
    </FullContainer>
  );
}